import React, { useEffect, useRef, useState } from "react";
import contentBanner from "./images/content-banner.jpg";
import useClientConfig from "../../../../../config/careers/clientConfig";

const WhyWorkWith: React.FC = () => {
    const {clientAssetsLink} = useClientConfig();
    const handleScrollListing = () => {
        const element = document.querySelector("#option4-job-list-parent");
        if (element) {
            const yOffset = -100; // Offset in pixels
            const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    };

    return (
        <div>
            <div className="ksps">
                <div className="row-fluid">
                <div className="col-12">
                    <h3>Why Work With Us?</h3>
                    <div className="column_ksps">
                        <div className="col-4"><h4>An experienced multi-disciplinary team</h4><p>
                            A leading process engineering consulting and contracting company that specialises in providing high quality 
                        engineering design and construction services to the mining and mineral processing industries. GR Engineering 
                        has a proven track record of delivering integrated project solutions.
                        </p></div>
                        <div className="col-4"><h4>Long term relationships driving value for our clients</h4><p>
                            GR Engineering personnel have an intimate appreciation of the company’s culture, ethics and values. Our 
                            most significant asset is the quality of our people together with our ability to develop and mentor new 
                            personnel.
                        </p></div>
                        <div className="col-4"><h4>Successful track record of ‘company-making’ projects</h4><p>
                            Providing services in over 20 countries for a vast range of precious, bulk and industrial commodities, 
                            GR Engineering has delivered ‘company making’ projects for mining companies recognising the critical 
                            importance of cost, time and performance to all stakeholders.
                        </p></div>
                    </div>
                </div>
                </div>
            </div>
            <div className="Our_values">
                <div className="row-fluid">          
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ourvalues">
                    <img alt="" src={clientAssetsLink+"/content-banner.jpg"} />
                </div>            
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 bottom_space">
                    <h3>Our Values</h3>
                    <p> 
                        GR Engineering is founded on a strong belief in its core values. These core values 
                        drive its people and underpin the Company’s corporate goals of providing clients 
                        with superior service, establishing safe and effective working relationships as 
                        well as respect for the culture, diversity and values of others.
                    </p>
                    <p>
                        The following Core Values drive our people and underpin our corporate goals.
                    </p>
                    <ul>
                    <li>Provision of a safe, healthy and hazard free workplace</li>
                    <li>Our clients are our focus</li>
                    <li>A commitment to innovation and quality</li>
                    <li>Our people are our most significant asset</li>
                    <li>We will always act with honesty and integrity</li>
                    <li>Respect for the community and the environment</li>
                    </ul>
                    <p> Our Values support our Vision, “to be a market leader in safe, quality, cost
                    competitive and timely engineering solutions to the global mineral processing market”.
                    </p>

                    <div className="job-apply-btn">
                    <div className="learn_btn" onClick={handleScrollListing}>
                        <a className="homeredirect"  >Current Vacancies</a>    
                    </div>
            
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default WhyWorkWith;